"use client";

import { c as _c } from "react/compiler-runtime";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { type ReactNode, useEffect, useState } from "react";
export function QueryProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== queryClient) {
    t1 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const localStoragePersister = createAsyncStoragePersister({
        storage: window.localStorage,
        key: "REACT_QUERY_CACHE",
        throttleTime: 1000
      });
      persistQueryClient({
        queryClient,
        persister: localStoragePersister,
        maxAge: 86400000
      });
    };
    t2 = [queryClient];
    $[0] = queryClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ReactQueryDevtools initialIsOpen={false} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== queryClient) {
    t4 = <QueryClientProvider client={queryClient}>{children}{t3}</QueryClientProvider>;
    $[4] = children;
    $[5] = queryClient;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60000,
        gcTime: 300000,
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnMount: "always"
      }
    }
  });
}